import { pathRegexMap, accessMaps } from "./accessMap";
import checkIsAdmin from "./checkIsAdmin";

interface Returning {
  isAdm: boolean;
}

    export default async function checkBefore (locPathName:string, urlProp?:string, actionName?:string, ): Promise<Returning> {

        // console.log('locPathNamelocPathName ', locPathName, urlProp, actionName);

      //  let path: keyof typeof accessMaps | undefined;

      //   if (locPathName.includes("/documents/incoming")) path = "incoming";
      //   else if (locPathName.includes("/documents/outcoming")) path = "outcoming";
      //   else if (locPathName.includes("/documents/internal")) path = "internal";
      //   else if (locPathName.includes("/documents/resolutions")) path = "resolutions";
      //   else if (locPathName.includes("/documents/for-signature")) path = "forsignature";
      //   else if (locPathName.includes("/documents/electronic-mail")) path = "electronicmail";
      //   else if (locPathName.includes("/directories/types-of-documents")) path = "typesofdocuments";
      //   else if (locPathName.includes("/directories/document-categories")) path = "documentategories";
      //   else if (locPathName.includes("/directories/indexes-of-documents")) path = "indexesofdocuments";
      //   else if (locPathName.includes("/directories/actions-with-documents")) path = "actionswithdocuments";
      //   else if (locPathName.includes("/directories/results-of-actions")) path = "resultsofactions";
      //   else if (locPathName.includes("/directories/nomenclature-of-cases-current")) path = "nomenclatureofcasescurrent";
      //   else if (locPathName.includes("/directories/nomenclature-of-cases")) path = "nomenclatureofcases";
      //   else if (locPathName.includes("/directories/types-of-deliveries")) path = "typesofdeliveries";
      //   else if (locPathName.includes("/directories/types-of-communication")) path = "typesofcommunication";
      //   else if (locPathName.includes("/directories/resolution-templates")) path = "resolutiontemplates";
      //   else if (locPathName.includes("/directories/types-of-relationships-between-documents")) path = "typesofrelationshipsbetweendocuments";
      //   else if (locPathName.includes("/directories/types-of-receipts")) path = "typesofreceipts";
      //   else if (locPathName.includes("/directories/structural-units")) path = "structuralunits";
      //   else if (locPathName.includes("/directories/types-of-structural-unit")) path = "typesofstructuralunit";
      //   else if (locPathName.includes("/directories/positions")) path = "positions";
      //   else if (locPathName.includes("/directories/job-categories")) path = "jobcategories";
      //   else if (locPathName.includes("/directories/profession-classifier")) path = "professionclassifier";
      //   else if (locPathName.includes("/directories/groups-of-correspondents")) path = "groupsofcorrespondents";
      //   else if (locPathName.includes("/directories/departmental-journals")) path = "departmentaljournals";
      //   else if (locPathName.includes("/directories/employees-and-contact-persons")) path = "employeesandcontactpersons";
      //   else if (locPathName.includes("/directories/employees")) path = "employees";

      //   console.log('locPathNamelocPathNamepath ', path);

      //   if (!path) {
      //       alert('Перевір та додай маршрути для цієї сторінки щоб перевірити доступ selectionOfActions!');
      //       console.warn("Unknown document type in path:", locPathName);
      //     return { isAdm: false };
      //   }

       const match = pathRegexMap.find(([regex]) => regex.test(locPathName))

         if (!match) {
          // alert('Перевір та додай маршрути для цієї сторінки щоб перевірити доступ selectionOfActions!');
          // console.warn("Unknown path:", locPathName)
          return { isAdm: false }
        }

         const [, path] = match

        // console.log('ACTIONNAME ', actionName);

        const map = accessMaps[path];
        const keysToTry = urlProp ? [`${urlProp}:${locPathName}::${actionName}`] : [`${locPathName}::${actionName}`/*, `${locPathName}:${actionName}`*/];

        // console.log('keysToTry ', keysToTry);

        const key = keysToTry.find((k) => k && map?.[k]);
        const nameAction = key ? map[key] : undefined;

        // console.log('keyy ', key);
        // console.log("Key to check:", JSON.stringify(keysToTry[0]))
        // console.log("All map keys:", Object.keys(map))

        if (!nameAction) {
            // alert('Перевір та додай nameAction для цієї сторінки щоб перевірити доступ selectionOfActions!');
            // console.warn("Unknown document type in nameAction:", nameAction);
          return { isAdm: false };
        }

        // const nameAction = map?.[key];
        // console.log('checkIsAdminValue ', locPathName, nameAction);


        const isAdm = await checkIsAdmin(locPathName, nameAction);

        return isAdm;
  };
